// *** import AWS from "aws-sdk";
import {
  CognitoUserPool,
// ***   CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails
} from "amazon-cognito-identity-js";

import React from 'react';
// *** import { userIdFunc, handleErrorFunc } from '../App';
import { handleErrorFunc } from '../App';

import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import appConfig from '../appConfig';


export default class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      oldpassword: "",
      newpassword1: "",
      newpassword2: ""
    };
  }

  componentWillMount() {
    const email = localStorage.getItem('email');
    console.log("### email="+email);
    this.setState({email: email});
  }

  handleOldPasswordChange(e) {
    this.setState({oldpassword: e.target.value});
  }
  handleNewPassword1Change(e) {
    this.setState({newpassword1: e.target.value});
  }
  handleNewPassword2Change(e) {
    this.setState({newpassword2: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();
    const _self = this;
    const email = this.state.email;

    if( !email ) {
        handleErrorFunc('エラー：ログインしていません');
        return;
    }

    const oldpassword = this.state.oldpassword.trim();
    const newpassword1 = this.state.newpassword1.trim();
    const newpassword2 = this.state.newpassword2.trim();

    if(newpassword1 !== newpassword2) {
        handleErrorFunc('エラー：確認用パスワードが一致しません。');
        return;
    }

    const authenticationData = {
        Username : email,
        Password : oldpassword,
    };
    var authenticationDetails = new AuthenticationDetails(authenticationData);

    const userPool = new CognitoUserPool({
      UserPoolId: appConfig.UserPoolId,
      ClientId: appConfig.ClientId,
    });
    const userData = {
        Username : email,
        Pool : userPool
    };
    var cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result1) {
            cognitoUser.changePassword(oldpassword, newpassword1, function(err, result) {
                if (err) {
                    alert(err);
                    handleErrorFunc('エラー：パスワード変更に失敗しました: '+err);
                    return;
                }
                _self.setState({oldpassword: ""});
                _self.setState({newpassword1: ""});
                _self.setState({newpassword2: ""});
                //console.log('call result: ' + result);
            });
        },
        onFailure: function(err) {
            alert(err);
        },
    });
  }

  render () {
    const style = {
      width: '80%',
      margin: 50,
      padding: 50,
      display: 'inline-block',
    };
    return (
      <div>
        <Paper style={style} zDepth={1}>
          <h2 style={{textAlign: 'left'}}>パスワード変更</h2>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <TextField fullWidth={true}
                 value={this.state.oldpassword}
                 hintText="現在のパスワード"
                 onChange={this.handleOldPasswordChange.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.newpassword1}
                 hintText="新パスワード"
                 onChange={this.handleNewPassword1Change.bind(this)}/><br />
            <TextField fullWidth={true}
                 value={this.state.newpassword2}
                 hintText="新パスワード（確認用）"
                 onChange={this.handleNewPassword2Change.bind(this)}/><br />
            <input type="submit"/>
          </form>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ChangePasswordView.js